import React from "react";
//#region types
import { ClassifiedReceiptFooterProps } from "models/propTypes/receiptPropTypes";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { PageFooter } from "components/common";
import ClassifiedReceiptMoreActions from "./classifiedReceiptMoreActions";
//#endregion
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";
import { receiptCreatedFromClassification } from "store/actions/receiptActions";

const ClassifiedReceiptFooter: React.FC<ClassifiedReceiptFooterProps> = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const handleSubmit = async () => {
    const result = await (props.formRef?.current?.submit() || Promise.resolve());
    if (result !== null && result !== undefined) {
      dispatch(receiptCreatedFromClassification(props.classifiedReceipt.id));
      props.markAsDone();
    }
  };

  return (
    <PageFooter
      allowForReadOnlyUsers
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Submit),
          onClick: handleSubmit,
          type: StyleEnums.DisplayType.Success,
          successMessage: TranslationKeys.Receipt.DraftSendSuccess,
        },
      ]}
      moreActions={
        <ClassifiedReceiptMoreActions classifiedReceipt={props.classifiedReceipt} markAsDone={props.markAsDone} />
      }
    />
  );
};

export default ClassifiedReceiptFooter;
